import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {receivedShipment} from '../../../../services/api/apiNextBox'
import {Alert} from "reactstrap"

class ShippedModal extends Component {
    state = {
        loading: false,
        message: ''
    }

    _receivedShipment = async () => {
        this.setState({
            loading: true
        })

        try {
            const {itemId} = this.props
            const {success, message} = await receivedShipment(itemId)

            if (!success) {
                this.setState({
                    loading: false,
                    message: message
                })
            }

            this.setState({
                loading: false,
                message: ''
            })

            const {onToggleModal, fetchListBoxesItems} = this.props

            if (typeof onToggleModal === 'function' && typeof fetchListBoxesItems === 'function') {
                fetchListBoxesItems()
                onToggleModal()
            }

        } catch (e) {
            this.setState({
                message: e.message
            })
        }
    }

    render() {
        const {loading, message} = this.state
        const {isOpen, onToggleModal} = this.props

        return (
            <div className="ShippedModal">
                <Modal isOpen={isOpen} toggle={onToggleModal}>
                    <ModalHeader toggle={onToggleModal}>Đánh dấu đã nhận</ModalHeader>
                    <ModalBody>
                        {
                            message ? <Alert>{message}</Alert> :
                                <div>Bạn có chắc chắn đánh dấu item này khách hàng đã nhận được hàng?</div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={onToggleModal}>Hủy</Button>{' '}
                        <Button color="primary" onClick={this._receivedShipment} disabled={loading}>
                            {loading ? "Đang đánh dấu" : "Đánh dấu"}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ShippedModal.propTypes = {
    fetchListBoxesItems: PropTypes.func.isRequired
}

export default ShippedModal